export default __webpack_public_path__ + "static/scores@mob-738d9faea25c30eb7eb757bf6d833eb0.png";